module.exports = __webpack_public_path__ + "static/media/JSNMC2.58ccdfc7.png";